import React, { ReactElement, MouseEvent } from "react"
import {
	List,
	ListItem,
	ListItemText,
	ListItemSecondaryAction,
	CardActions,
	Button,
} from "@material-ui/core"
import { format } from "date-fns"
import { Link } from "react-router-dom"
import AddIcon from "@material-ui/icons/Add"
import { CFCStruct, CFCId } from "../../data/_config/shape"
import { canvasDisplayTitle } from "./__config/utilities"
import { routeVarReplacement, PrivateRoutes } from "../../util/routes/routes"
import IconDeleteButtonwDialog from "../IconDeleteButton/IconDeleteButtonwDialog"
import useStyles from "../Forms/CFC/__config/styles"
import IconEditButtonwDialog from "../IconEditButton/IconEditButtonwDialog"

interface CanvasListProps {
	data: CFCStruct[]
	remove: (id: CFCId) => Promise<void>
	edit: (item: CFCStruct) => Promise<void>
	canvasType: string
}

type ButtonClick = (e: MouseEvent<HTMLButtonElement>) => void

/**
 * Displays a list of canvases with a way to add a new one
 *
 * @export
 * @param {CanvasListProps} {
 * 	data,
 * 	remove,
 * }
 * @returns {ReactElement}
 */
export default function CanvasList({
	data,
	remove,
	edit,
	canvasType,
}: CanvasListProps): ReactElement {
	const styles = useStyles()

	/**
	 * Creates the link to the edit canvas page
	 *
	 * @param {CFCId} id
	 * @returns {string}
	 */
	function itemLink(item: CFCStruct): string {
		const query = new URLSearchParams()
		query.append("type", item.canvasType)

		if (item.canvasType == "wizard") {
			return `${routeVarReplacement(PrivateRoutes.PlanningStep1, [
				[":id", (item.id || "").toString()],
			])}`
		}
		return `${routeVarReplacement(PrivateRoutes.CFCEdit, [
			[":id", (item.id || "").toString()],
		])}?${query.toString()}`
	}

	/**
	 * Triggers the parent remove method
	 *
	 * @param {CFCId} id
	 * @returns {ButtonClick}
	 */
	function onDelete(id: CFCId): ButtonClick {
		return (e): void => {
			e.preventDefault()
			remove(id)
		}
	}

	/**
	 * Triggers the parent remove method
	 *
	 * @param {CFCId} id
	 * @returns {ButtonClick}
	 */
	function onEdit(item: CFCStruct, title: string): void {
		// return (e): void => {
		// e.preventDefault()
		item.canvasTitle = title

		edit(item)
		// }
	}

	/**
	 * Renders the canvas list item
	 *
	 * @param {CFCStruct} item
	 * @returns {ReactElement}
	 */
	function renderCanvas(item: CFCStruct): ReactElement {
		if (!item?.id) return <></>

		return (
			<ListItem key={item.id} button component={Link} to={itemLink(item)}>
				<ListItemText
					primary={
						canvasType == "wizard"
							? (item.canvasTitle ? item.canvasTitle : "Wizard") +
							  " " +
							  (item.canvasTitle
									? ""
									: format(item.canvasStartDate, "dd.MM.yyyy HH:MM"))
							: canvasDisplayTitle(item)
					}
					secondary={
						item.canvasStartDate && canvasType != "wizard"
							? format(item.canvasStartDate, "dd.MM.yyyy HH:MM")
							: false
					}
				/>
				<ListItemSecondaryAction>
					<IconDeleteButtonwDialog onClick={onDelete(item.id)} />
					<IconEditButtonwDialog
						title={item.canvasTitle}
						onTitleChange={(title: string) => onEdit(item, title)}
					/>
				</ListItemSecondaryAction>
			</ListItem>
		)
	}

	return (
		<>
			<List>{data.map(renderCanvas)}</List>
			<CardActions className={styles.box}>
				<Button
					variant="contained"
					color="primary"
					startIcon={<AddIcon />}
					component={Link}
					to={
						canvasType == "wizard"
							? PrivateRoutes.PlanningStep1
							: PrivateRoutes.CFC
					}
				>
					Kreirajte novi
				</Button>
			</CardActions>
		</>
	)
}
